import React from "react";
import {useHistory} from "react-router-dom";
import MaterialTable from "material-table";
import {tableIcons} from "../../shared/MaterialTableIcons";
import {ROUTES} from "../../utils/RouteConstants";

export default function NotesTable({
  last,
  tableData,
  tableHeaders,
  member
}) {

    let history = useHistory();

    return (
    <div>
        {console.log("note", tableData)}

        <MaterialTable
            title="Notes"
            icons={tableIcons}
            columns={tableHeaders.columns}
            data={tableData}
            actions={[
              {
                icon: tableIcons.Edit,
                tooltip: "Edit Note",
                onClick: (event, rowData) =>{
                  console.log("rowData", rowData);
                  history.push(ROUTES.NOTES_FORM, { last : last, note: {...rowData, tableData: null}, member:{...member}, edit: true });
                }

              },
            ]}
            options={{
              headerStyle: {
                backgroundColor: "var(--c1)",
                color: "#FFF",
              },
              actionsColumnIndex: -1
            }}
        />
    </div>
    )
}

